import { URL_UPDATE_MENU_ROLE } from 'constants/urls';
import { checkArrayOnlyType } from 'libs/types/checkTypes';

/**
 * @async
 * @function updateRoleApi
 * @param { Object[] } roles
 * @param { string } roles.groupId
 * @param { string } roles.id
 * @param { string } roles.name
 * @param { string } roles.desc
 * @param { string } roles.type
 * @param { boolean } roles.checked
 * @returns { string }
 */
async function updateRoleApi(roles) {
	checkArrayOnlyType(roles);

	const options = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
		body: JSON.stringify(roles),
	};

	const res = await fetch(URL_UPDATE_MENU_ROLE, options);

	if (!res.ok) {
		const message = `HTTP error! status: ${res.status}`;
		throw new Error(message);
	} else {
		const { msg } = await res.json();
		return msg;
	}
}

export default updateRoleApi;
